import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';
import Icon from '../../../components/Icon';
import { BranchSelector } from './BranchSelector';
import { CodeFlowHeader } from './CodeFlowHeader';
import Dashboard from './Dashboard';
import CommitsList from './CommitsList';
import { VCS_SLUG } from '../../../constants/api';
import RepositoryDetailDrawer from '../../../components/RepositoryDetailDrawer';
import { EmptyRepository } from './EmptyRepository';
import EmptyRepositoryPage from './EmptyRepositoryPage';
import MaintenanceBanner from '../../../components/MaintenanceBanner';
import { IS_APP_CODEAC } from '../../../constants/env';
import LoadingPlaceholder from '../../../components/LoadingPlaceholder';
import { handleBranchInUrl } from '../../../utils/repositoryNameAndOwner';
import { replaceSlashWithAsciiChar, resolveBranchName } from '../../../utils/resolveBranch';
import { LastCommitInfo } from './LastCommitInfo';
import { NoMainBranch } from './NoMainBranch';
import { TrialActivatedAlert } from './TrialActivatedAlert';
class ActiveRepository extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            showEmptyRepository: this.props.isEmpty ?? false,
        };
    }
    componentDidMount() {
        const { activeBranches, repository, match, history } = this.props;
        if (repository) {
            const fullname = repository.getFullName();
            const activeBranch = activeBranches ? activeBranches[repository.id] : null;
            try {
                handleBranchInUrl(
                // @ts-expect-error TS2345: Argument of type History is not assignable to parameter of type History<unknown>
                history, match, fullname, repository.slug, repository.getMainBranch().name, activeBranch?.name);
            }
            catch {
                this.setState({ showEmptyRepository: true });
            }
        }
    }
    renderLastCommitInfo() {
        const { activeBranches, repository, loadingBranches, onRefreshClick } = this.props;
        const mainBranch = repository.getMainBranch();
        const activeBranch = activeBranches ? activeBranches[repository.id] : mainBranch;
        const fullName = replaceSlashWithAsciiChar(repository.fullname).replace(/%2F/, '/');
        const branchName = resolveBranchName(activeBranch.name, mainBranch.name, activeBranch.main);
        const branch = repository.getBranchByName(branchName);
        const lastCommit = branch?.getLastCommit();
        const commitLink = `/${VCS_SLUG[repository.vcs]}/${fullName}${branchName && branchName !== mainBranch.name ? `${branchName}` : ''}/commits/${lastCommit?.hash}`;
        return _jsx(LastCommitInfo, { commitLink: commitLink, lastCommit: lastCommit, loadingBranches: loadingBranches, onRefreshClick: onRefreshClick });
    }
    renderRepositoryDetail(mainBranch, lastCommit, requestedBranch) {
        const { activeBranches, repository, repositoryUrl, branch, loadingBranches, loaded, match, onChangePage, trialNewlyActivated, processingPercentage, user, vcsLink, onBranchClick, t, } = this.props;
        const isCommitsLayout = match.url.substring(match.url.lastIndexOf('/') + 1, match.url.length) === 'commits';
        const activeBranch = activeBranches ? activeBranches[repository.id] : null;
        const lastCommitHash = activeBranch?.getLastCommit().hash;
        return (_jsxs("div", { className: "row", children: [_jsx(RepositoryDetailDrawer, { vcsSlug: VCS_SLUG[repository.vcs], fullName: repository.fullname, branch: branch !== mainBranch?.name ? branch : void 0, className: "col col-12 col-md-2", isUserLoggedIn: user.loggedIn }), _jsxs("div", { className: "col col-12 col-md-10 repository-detail__content", children: [repository.vcs && _jsx(MaintenanceBanner, { vcs: repository.vcs }), trialNewlyActivated && _jsx(TrialActivatedAlert, {}), _jsx(BranchSelector, { vcsLink: vcsLink, activeBranch: activeBranch || void 0, mainBranch: repository.getMainBranch(), repositoryVcs: repository.vcs, branchList: repository.branches, onBranchClick: onBranchClick }), !IS_APP_CODEAC && _jsx(CodeFlowHeader, { lastCommit: lastCommit, repositoryFullName: repository.fullname }), IS_APP_CODEAC && lastCommitHash && this.renderLastCommitInfo(), loadingBranches && (_jsxs("div", { className: "text-center", children: [IS_APP_CODEAC && !isCommitsLayout ? (_jsx("div", { className: "active-repository__loader", children: _jsx(LoadingPlaceholder, { type: "activeRepository", count: 1 }) })) : (_jsx(Icon, { name: "spinner", spin: true, fixedWidth: true, size: "2x" })), _jsxs("span", { className: "sr-only", children: [t('loading'), "..."] })] })), !loadingBranches && Object.keys(repository.branches).length === 0 && _jsx(EmptyRepositoryPage, {}), !loadingBranches && Object.keys(repository.branches).length && (_jsx("div", { children: !mainBranch ? (_jsx(NoMainBranch, { repository: repository, requestedBranch: requestedBranch, user: user.user })) : (_jsxs(Switch, { children: [_jsx(Route, { path: repositoryUrl + '/:branch?/commits', render: () => (_jsx(CommitsList, { repository: repository, onChangePage: onChangePage, processingPercentage: processingPercentage, loaded: loaded })) }), _jsx(Route, { path: repositoryUrl + '/:branch?', exact: true, render: () => (_jsx(Dashboard, { activeBranch: activeBranch, repository: repository, processingPercentage: processingPercentage, showCodeCoverage: IS_APP_CODEAC && Object.keys(repository.codeCoverage?.commits ?? {}).length > 0 })) })] })) }))] })] }));
    }
    render() {
        const { activeBranches, repository, user } = this.props;
        const { showEmptyRepository } = this.state;
        if (showEmptyRepository) {
            return _jsx(EmptyRepository, { user: user.user, repository: repository, isUserLoggedIn: user.loggedIn });
        }
        const activeBranch = Object.keys(activeBranches).length ? activeBranches[repository.id] : null;
        try {
            const mainBranch = repository.getMainBranch();
            const branch = activeBranch ?? mainBranch;
            // TODO: here is branch not type Branch so we can't call the method on the entity
            const lastCommit = branch.getLastCommit();
            return this.renderRepositoryDetail(mainBranch, lastCommit, mainBranch);
        }
        catch (error) {
            console.error(error);
            // ToDo: Probably not the best solution to show empty page when error occurs. Better to inform the user about the issue.
            return _jsx(EmptyRepository, { user: user.user, repository: repository, isUserLoggedIn: user.loggedIn });
        }
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
    activeBranches: state.activeBranches,
});
export default connect(mapStateToProps)(withTranslation()(ActiveRepository));
